import {useEffect, useState} from 'react';
import {useApp} from '../../../contexts/AppContext';
import styled from 'styled-components';
import config from '../../../config';
import {PageMainTitle} from '../../atoms/CommonParts';

const Page = styled.div`
  @media ${config.layout.wide} {
  }
`;

const DocumentContent = styled.div`
  margin-top: 40px;
  font-size: 14px;
  font-weight: 500;
  line-height: 26px;

  p {
    margin-bottom: 38px;
  }
`;

const DocumentTitle = styled.div`
  text-align: center;
  margin-top: 60px;
  margin-bottom: 60px;
  font-size: 16px;
  font-weight: bold;
`;

const DocumentIssuedDate = styled.div`
  font-size: 14px;

  span {
    &:first-child {
      font-weight: bold;
      margin-right: 10px;
    }
  }
`;

const DocumentBorder = styled.hr`
  margin-top: 60px;
  margin-bottom: 120px;
  height: 1px;
  background-color: #000000;
  border: none;
  opacity: 1;
`;


const SectionBorder = styled.hr`
  margin-top: 38px;
  margin-bottom: 40px;
  height: 1px;
  background-color: #d9d9d9;
  border: none;
  opacity: 0.3;
`;

const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 25px;

  span {
    width: 55px;
    font-weight: bold;
  }

  h2 {
    font-size: 14px;
    font-weight: bold;
    line-height: 26px;
  }
`;

const SectionContent = styled.div`
  display: flex;
  margin-bottom: 30px;

  ul {
    list-style-type: disc;

    li {
      margin-bottom: 15px;
    }
  }

  & > span:first-child {
    width: 45px;
    flex: 0 0 auto;
    @media ${config.layout.wide} {
      width: 50px;
    }

    &.li1 {
      text-align: right;
      padding-right: 10px;

      &:after {
        content: "●";
        font-weight: bold;
      }
    }
  }

  h3 {
    font-size: 14px;
    font-weight: bold;
    line-height: 26px;
    margin-bottom: 5px;
  }

  p {
    margin-bottom: 20px;
  }
`;

export default function TermsOfUsePage() {
  const app = useApp();

  useEffect(() => {
    app.showHeader();
    document.title = 'Terms of Use';
  }, []);

  return (
      <Page>
        <PageMainTitle>
          <span>Terms of Use</span>
        </PageMainTitle>
        <hr className="simple-border"/>
        <DocumentContent>
          <DocumentTitle>KUVO Venue Registration Consent Form</DocumentTitle>
          <p>
            By registering for KUVO and by providing your venue name/location,
            room/floor and details of the Pioneer DJ equipment used, your venue
            becomes eligible for KUVO Care extended warranty on the CDJ-3000
            equipment registered, and can gain access to the KUVO for Venues
            music insights dashboard.
          </p>
          <p>
            By agreeing to the KUVO beta software terms of use and by
            registering for the KUVO service, you hereby authorize AlphaTheta
            Corporation (ATC) (owner of brands Pioneer DJ and KUVO) to, without
            fee:
          </p>
          <SectionContent>
            <ul>
              <li>
                <p>
                  Collect various types of information relating to the music
                  played in your venue including:
                </p>
                <ul>
                  <li>the time the music was played;</li>
                  <li>the frequency with which the music was played;</li>
                  <li>the location of where the music was played;</li>
                  <li>the individual track details (if available); and</li>
                  <li>other similar types of information reasonably required by
                    ATC from time to time for the purposes of improving or
                    evolving its KUVO service.
                  </li>
                </ul>
              </li>
            </ul>
          </SectionContent>
          <p>
            The KUVO technology does not collect personal information about the
            DJ. The information collected about music played does not identify
            the performing DJs, unless additional permissions are agreed by the
            DJ and / or venue.
          </p>
          <p>
            The information collected may be used in the following ways:
          </p>
          <SectionContent>
            <ul>
              <li>
                To provide trend and summary analysis to you as a
                KUVO-registered venue, on what is played at your events.
              </li>
              <li>
                Venue name, location, room/floor and music play information may
                be sent to registered CMOs (Collective Management Organizations)
                for their internal use only, to facilitate more accurate royalty
                payments to creators and rightsholders of the music which DJs
                play. Note - CMOs are restricted from sharing KUVO data with any
                other parties.
              </li>
              <li>
                It may be combined, improved and ‘enriched’ with other relevant
                data by us or our partners (including DJ Monitor).
              </li>
              <li>
                It may be combined with other relevant data to create regional
                and national club play charts.
              </li>
              <li>
                To provide regional and national track performance or trend and
                summary analysis (on a track-by-track, group or other basis) to
                artists, rightsholders, rights users and their stakeholders for
                their internal use only.
              </li>
              <li>
                It may be used for any other purpose(s) that ATC reasonably
                considers necessary for improving or evolving its KUVO service.
              </li>
            </ul>
          </SectionContent>
          <p>
            No information identifying your venue will be provided to CMOs, if
            venues do not register for KUVO nor consent to this form.
            <br/>
            If you have anything unclear, please feel free to inquiry the below
            e-mail address: support@kuvo.com
          </p>
        </DocumentContent>
        <DocumentBorder/>
        <DocumentContent>

          <DocumentIssuedDate>
            <span>Issued Date:</span>
            <span>July 1st, 2023  ("Effective Date")</span>
          </DocumentIssuedDate>

          <DocumentTitle>Terms of Use (For the venues)</DocumentTitle>
          <p>
            This Terms of Use document (“Agreement”) applies to KUVO dashboard
            service (“Services”). This Agreement is by and between <b>AlphaTheta
            Corporation a company registered in Japan whose company address is
            6F Yokohama i-Mark Place, 4-4-5 Minatomirai, Nishi-ku, Yokohama,
            Kanagawa 220-0012 Japan ("AlphaTheta")</b> and the organization
            agreeing
            to these terms (“Recipient”).This Agreement governs access to and
            use of the Services and any Beta Services.:
          </p>
          <p>
            Taking any step to use the Service means that You accept all of the
            terms of this Agreement. Permission to use the Service is
            conditional on You agreeing to and complying with the terms of this
            Agreement. Written or electronic approval by AlphaTheta is not
            required to make this Agreement valid and enforceable. If You do not
            agree to all of the terms of this Agreement, You are not authorized
            to use the Service and must stop use it, as applicable.
          </p>
          <p>
            We may change this Agreement from time to time. If we make any
            changes, we will notify you by revising the "Last Updated" date at
            the top of this Agreement and where appropriate we may provide you
            with additional notice (such as adding a statement to the log-in
            screen or sending you an e-mail notification). Your continued use of
            our Services after the revised Agreement has become effective
            indicates that you have read, understood, and agreed to the current
            version of this Agreement.
          </p>
          <SectionBorder/>
          <SectionTitle>
            <span>1.</span>
            <h2>Service and Fee</h2>
          </SectionTitle>
          <SectionContent>
            <span>1.1.</span>
            <div>
              AlphaTheta will provide Recipient the data about the musics
              which is played in Recipient’s own venues via the system
              designated by AlphaTheta for Service (“Data”) during the term of
              this Agreement subject to the terms and conditions contained
              herein for Recipient for their internal use only (the “Purpose”)
              in the country where Recipient operates its business (the
              “Service”). AlphaTheta may at any time discontinue the Service by
              providing Recipient thirty (30) days notice of its intent to
              discontinue the Service.
            </div>
          </SectionContent>
          <SectionContent>
            <span>1.2.</span>
            <div>
              This Service is available at no charge. AlphaTheta may at any time
              change the Service fee (“Fee”) by providing Recipient thirty (30)
              days notice of such change. If Recipient does not agree to such
              change in Fee, the Recipient may terminate this Agreement by
              providing AlphaTheta thirty (30) days written notice specifying
              the reason for termination.
            </div>
          </SectionContent>
          <SectionBorder/>
          <SectionTitle>
            <span>2.</span>
            <h2>Data</h2>
          </SectionTitle>
          <SectionContent>
            <span>2.1.</span>
            <div>
              The Data provided under the Service consists solely of the tracks
              being played through the system designated by AlphaTheta
              for Service, and therefore may not include the data of all of the
              tracks being played at a particular club.
            </div>
          </SectionContent>
          <SectionContent>
            <span>2.2.</span>
            <div>
              Recipient shall not download the Data.
            </div>
          </SectionContent>
          <SectionBorder/>
          <SectionTitle>
            <span>3.</span>
            <h2>No warranty</h2>
          </SectionTitle>
          <SectionContent>
            <span>3.1.</span>
            <div>
              THE DATA IS PROVIDED “AS IS” AND ALPHATHETA OFFERS AND RECIPIENT
              RECEIVES NO WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, BY
              STATUTE, COMMUNICATION OR CONDUCT WITH RECIPIENT, OR OTHERWISE.
              ALPHATHETA SPECIFICALLY DISCLAIMS ANY IMPLIED WARRANTY OF FITNESS
              FOR A PARTICULAR PURPOSE. WITHOUT LIMITATION OF THE ABOVE,
              ALPHATHETA PROVIDES NO WARRANTY THAT DATA IS ERROR-FREE OR WILL BE
              PROVIDED WITHOUT INTERRUPTION, AND PROVIDES NO WARRANTY REGARDING
              ITS USE OR THE RESULTS THEREFROM INCLUDING, WITHOUT LIMITATION,
              ITS CORRECTNESS, ACCURACY OR RELIABILITY.
            </div>
          </SectionContent>
          <SectionContent>
            <span>3.2.</span>
            <div>
              AlphaTheta shall not be responsible for any damages which may
              result from Recipient’s use of the Data and/or the Service, or
              discontinuance of the Service, and Recipient shall be solely
              responsible for such damages.
            </div>
          </SectionContent>
          <SectionContent>
            <span>3.3.</span>
            <div>
              Limitation of Liability. In no event will AlphaTheta or its
              subsidiaries be liable in connection with this Agreement or its
              subject matter, under any theory of liability, for any indirect,
              incidental, special, consequential or punitive damages, or damages
              for lost profits, revenue, business, savings, data, use, or cost
              of substitute procurement, even if advised of the possibility of
              such damages or if such damages are foreseeable. In no event will
              AlphaTheta's liability for all damages exceed the amounts actually
              paid by Recipient to AlphaTheta or its subsidiaries for the
              Service. The parties acknowledge that the liability limits and
              risk allocation in this Agreement are reflected in the Service
              price and are essential elements of the bargain between the
              parties, without which AlphaTheta would not have provided the
              Service or entered into this Agreement.
            </div>
          </SectionContent>
          <SectionBorder/>
          <SectionTitle>
            <span>4.</span>
            <h2>Ownership</h2>
          </SectionTitle>
          <SectionContent>
            <span>4.1.</span>
            <div>
              AlphaTheta grants Recipient only the limited rights that are
              reasonably necessary for Recipient to use the Services.
            </div>
          </SectionContent>
          <SectionContent>
            <span>4.2.</span>
            <div>
              AlphaTheta or its licensor retains all right, title and interest
              in and to all patent, copyright, trade mark, trade secret and
              other intellectual property rights in the Services, Beta Services
              and Documentation, and any derivative works thereof. Recipient do
              not acquire any other rights, express or implied, beyond the
              limited license set forth in this Agreement.
            </div>
          </SectionContent>
          <SectionBorder/>
          <SectionTitle>
            <span>5.</span>
            <h2>Indemnification</h2>
          </SectionTitle>
          <SectionContent>
            <span>5.1.</span>
            <div>
              Recipient agrees to defend, indemnify and hold harmless
              AlphaTheta, its affiliates, and licensors from and against any and
              all claims, losses, liabilities, damages, settlements, expenses,
              and costs (including, without limitation, reasonable attorney’s
              fees and court costs) arising out of or related to:
            </div>
          </SectionContent>

          <SectionContent>
            <span></span>
            a) Recipient’s breach of any of the terms under this Agreement; and
          </SectionContent>
          <SectionContent>
            <span></span>
            b) complaints, allegations, lawsuits, or threat of law suits against
            AlphaTheta by DJs and/or rights holders (including, but not limited
            to song writers and composers) that they did not receive from
            Recipient the copyright distribution which they should have received
            by using the Data.
          </SectionContent>

          <SectionContent>
            <span>5.2.</span>
            <div>
              AlphaTheta agrees to notify Recipient promptly of any such claim,
              and to furnish Recipient with all information and documents
              pertaining to such claim and Recipient may assume control of the
              defense or settlement of such claim.
            </div>
          </SectionContent>

          <SectionBorder/>
          <SectionTitle>
            <span>6.</span>
            <h2>Term and Termination</h2>
          </SectionTitle>
          <SectionContent>
            <span>6.1.</span>
            <div>
              <h3>Termination for Cause</h3>
            </div>
          </SectionContent>

          <SectionContent>
            <span>6.1.1.</span>
            <div>
              AlphaTheta may terminate this Agreement if Recipient materially
              breaches this Agreement and fails to cure the breach to
              AlphaTheta’s satisfaction within thirty (30) days after receiving
              written notice.
            </div>
          </SectionContent>

          <SectionContent>
            <span>6.1.2.</span>
            <div>
              Either Party may terminate this Agreement if the other Party (i)
              begins dissolution or liquidation proceedings, or ceases to carry
              on its business, (ii) has a receiver or similar officer appointed
              and not discharged within ninety (90) days, (iii) makes an
              assignment for the benefit of creditors, or another arrangement of
              similar import, (iv) has proceedings under any bankruptcy or
              insolvency law commenced against it, which are not discontinued
              within ninety (90) days.
            </div>
          </SectionContent>

          <SectionContent>
            <span>6.2.</span>
            <div>
              <h3>Termination for Convenience</h3>
              AlphaTheta may terminate this Agreement for convenience upon
              thirty (30) days prior written notice to Recipient.
            </div>
          </SectionContent>

          <SectionContent>
            <span>6.3.</span>
            <div>
              <h3>Effects of Termination</h3>
            </div>
          </SectionContent>

          <SectionContent>
            <span>6.3.1.</span>
            <div>
              Upon termination of this Agreement, Recipient shall cease to use
              the Data in any way within fourteen (14) days of the termination.
              Notwithstanding the foregoing, the Recipient may, by obtaining
              prior consent of AlphaTheta, continue to use the Data for a period
              of three (3) months post termination of this Agreement solely for
              the Purpose in the case that the termination is caused by
              AlphaTheta subject to Section 6.1.
            </div>
          </SectionContent>
          <SectionContent>
            <span>6.3.2.</span>
            <div>
              Sections 1.2 (Fees), 3 (No Warranty), 5 (Indemnification), 6.4
              (Effects of Termination), 7(Confidentiality), and 8 (General
              Provisions) will survive this Agreement’s expiration or
              termination. Except as otherwise provided herein, termination will
              not waive or release either Party’s liability for breaching any
              obligations under this Agreement. Neither Party will be liable for
              damages of any kind solely for terminating this Agreement
              according to its terms.
            </div>
          </SectionContent>
          <SectionBorder/>
          <SectionTitle>
            <span>7.</span>
            <h2>Confidentiality</h2>
          </SectionTitle>
          <SectionContent>
            <span>7.1.</span>
            <div>
              <h3>Confidential Information</h3>
              Recipient acknowledges that as part of the Service, Recipient
              receives Confidential Information from AlphaTheta. “Confidential
              Information” shall mean any information including, without
              limitation, the Data, technical and economic information,
              commercialization, marketing and research strategies, trade
              secrets and know-how, which is confidential and proprietary in
              nature for AlphaTheta.
            </div>
          </SectionContent>
          <SectionContent>
            <span>7.2.</span>
            <div>
              <h3>Exclusions</h3>
              Confidential Information does not include information that (i)
              becomes part of the public domain (other than through a breach of
              this Agreement); (ii) was rightfully known by Recipient prior to
              receipt from AlphaTheta; (iii) comes into Recipient’s possession
              through lawful means from a third party with no obligation to
              maintain its confidentiality; (iv) Recipient can show was
              independently developed by it without use of or reference to the
              Confidential Information. Recipient has the burden of proof as to
              any such exception.
            </div>
          </SectionContent>
          <SectionContent>
            <span>7.3.</span>
            <div>
              <h3>Restrictions on Use and Disclosure</h3>
              Recipient shall not disclose Confidential Information to any third
              party or use it except for the Purpose. To avoid disclosure of the
              Confidential Information, the Recipient shall use at least the
              degree of care as it uses with respect to protecting its own
              proprietary information of like importance, but no less than the
              reasonable degree of care and limit the dissemination thereof to
              only those of its employees and officers who need access in order
              to achieve the Purpose and who are bound by written
              confidentiality obligations at least as restrictive as this
              Section 6. However, for the personally identifiable information
              contained in the Data, Recipient shall use its highest degree of
              care in avoiding disclosure.
            </div>
          </SectionContent>
          <SectionContent>
            <span>7.4.</span>
            <div>
              <h3>Compelled Disclosure</h3>
              If Recipient is compelled by order of a court, regulatory agency
              or other governmental body to disclose any of AlphaTheta’s
              Confidential Information, the Recipient shall promptly notify the
              AlphaTheta and cooperate, at AlphaTheta’s expense, in opposing or
              seeking to limit the order. If AlphaTheta declines to oppose the
              order, or the effort is ultimately unsuccessful, Recipient may
              disclose Confidential Information only to the extent required to
              comply with the order.
            </div>
          </SectionContent>
          <SectionContent>
            <span>7.5.</span>
            <div>
              <h3>Injunctive Relief</h3>
              Recipient agrees that its breach of this Section 6 may result in
              irreparable harm to AlphaTheta for which money damages would be
              inadequate. Accordingly, AlphaTheta will be entitled to seek
              immediate equitable and other provisional relief, including
              without limitation specific performance of this Agreement and a
              temporary restraining order and/or preliminary and /or permanent
              injunction, as a remedy for such breach, in addition to all other
              remedies available to such party at law or in equity and without
              prejudice to any such other remedies.
            </div>
          </SectionContent>
          <SectionBorder/>
          <SectionTitle>
            <span>8.</span>
            <h2>General Provisions</h2>
          </SectionTitle>
          <SectionContent>
            <span>8.1.</span>
            <div>
              <h3>Relationship of Parties</h3>
              Nothing in this Agreement creates any relationship between the
              Parties other than that of independent contractors. Neither Party
              will hold itself out as an agent, subsidiary, or affiliate of the
              other Party or has any authority to bind the other Party to any
              third party obligations.
            </div>
          </SectionContent>
          <SectionContent>
            <span>8.2.</span>
            <div>
              <h3>Entire Agreement and Modifications </h3>
              <p>
                This Agreement constitutes the entire understanding between the
                Parties with respect to its subject matter and supersedes all
                prior and cotemporaneous oral and written agreements, memoranda,
                understandings, undertakings, representations and warranties.
              </p>
              <p>
                No alteration, modification, or amendment to this Agreement
                shall be effective unless so altered, modified, or amended in
                writing and signed by the duly authorized representative of each
                Party.
              </p>
            </div>
          </SectionContent>
          <SectionContent>
            <span>8.3.</span>
            <div>
              <h3>Waiver</h3>
              No failure, delay or forbearance on the part of any Party in
              exercising any right or power under this Agreement shall operate
              as a waiver thereof and no waiver by any Party of any breach of
              any term or condition in this Agreement by the other Party shall
              constitute a continuing waiver or prejudice the rights of the
              non-breaching Party in respect of any other or subsequent breach
              of any term or condition in this Agreement.
            </div>
          </SectionContent>
          <SectionContent>
            <span>8.4.</span>
            <div>
              <h3>Assignment</h3>
              Recipient may not assign or transfer the Agreement or any rights
              or obligations under the Agreement without the written consent of
              AlphaTheta. AlphaTheta may not assign the Agreement without
              providing notice to Recipient, except AlphaTheta may assign the
              Agreement or any rights or obligations under the Agreement to an
              Affiliate or in connection with a merger, acquisition, corporate
              reorganization, or sale of all or substantially all of its assets
              without providing notice. Any other attempt to transfer or assign
              is void.
            </div>
          </SectionContent>
          <SectionContent>
            <span>8.5.</span>
            <div>
              <h3>Force Majeure</h3>
              Neither Party will be considered in breach or default under this
              Agreement for any delay or failure to perform any or all of its
              obligations resulting from extraordinary causes beyond that
              party’s control, such as acts of God, natural disasters, war or
              civil disruption, terrorism, public utility failures, operation of
              law, fire, explosion, any strike, lockout or other industrial
              action.
            </div>
          </SectionContent>
          <SectionContent>
            <span>8.6.</span>
            <div>
              <h3>Severability</h3>
              Any provision of this Agreement held unenforceable or illegal by a
              court of competent jurisdiction will be severable from the
              remaining Agreement, which will continue in full force and effect.
            </div>
          </SectionContent>
          <SectionContent>
            <span>8.7.</span>
            <div>
              <h3>Arbitration</h3>
              Any dispute, controversy, or difference which may arise between
              the Parties out of or in relation to or in connection with this
              Agreement, or any breach hereof, shall be settled amicably between
              the Parties, but in the event no amicable settlement can be
              reached, shall be finally settled by arbitration in Tokyo, Japan
              in accordance with the Commercial Arbitration Rules of the Japan
              Commercial Arbitration Association. The award of arbitration shall
              be final and binding upon both parties and shall have the
              reasoning therein.
            </div>
          </SectionContent>
          <SectionContent>
            <span>8.8.</span>
            <div>
              <h3>Governing Law</h3>
              <p>
                This Agreement shall be governed and construed by and under the
                laws of Japan excluding the conflict of laws.
              </p>
              <p>
                Recipient agrees to observe and comply at Recipient’s sole cost
                and expense with all applicable laws (including but not limited
                to the governing law set out above in this clause 8.8, as well
                as all relevant data protection laws), ordinances, rules,
                regulations, and requirements of any governmental authority, as
                may be applicable to Recipient in connection with Recipient’s
                use of the Services, Data and Recipient’s obligations under this
                Agreement.
              </p>
            </div>
          </SectionContent>
        </DocumentContent>
        <DocumentBorder/>
        <DocumentContent>

          <DocumentIssuedDate>
            <span>Issued Date:</span>
            <span>July 1st, 2023  ("Effective Date") </span>
          </DocumentIssuedDate>

          <DocumentTitle>Firmware Terms of Use</DocumentTitle>
          <p>
            These Version Firmware Terms of Use ("Terms of Use") are between you
            (both the individual installing the Firmware and any single legal
            entity for which the individual is acting) (“You” or “Your”) and
            ALPHATHETA CORPORATION ("AlphaTheta").
          </p>
          <p>
            Taking any step to set up or install the Firmware means that you
            accept all of the terms of these Terms of Use. Permission to
            download and/or use the Firmware is conditional on you agreeing to
            and complying with these Terms of Use and the Kuvo Venue
            Registration Consent Form. Written or electronic approval is not
            required to make these Terms of Use valid and enforceable. If you do
            not agree to all of the terms of these Terms of Use, you are not
            authorized to use the Firmware and must stop installing it or
            uninstall it, as applicable.
          </p>
          <p>
            We may change this Agreement from time to time. If we make any
            changes, we will notify you by revising the "Last Updated" date at
            the top of this Agreement and where appropriate we may provide you
            with additional notice (such as adding a statement to the log-in
            screen or sending you an e-mail notification). Your continued use of
            our Services after the revised Agreement has become effective
            indicates that you have read, understood, and agreed to the current
            version of this Agreement.
          </p>

          <SectionTitle>
            <span>1.</span>
            <h2>DEFINITIONS</h2>
          </SectionTitle>
          <SectionContent>
            <span>1.1.</span>
            <div>
              “Documentation” means written documentation, specifications and
              help content made generally available by AlphaTheta to aid in
              installing and using the Firmware.
            </div>
          </SectionContent>
          <SectionContent>
            <span>1.2.</span>
            <div>
              “Firmware” means all or any part of AlphaTheta’s Firmware
              (including it’s beta version) licensed to You by AlphaTheta under
              these Terms of Use.
            </div>
          </SectionContent>

          <SectionTitle>
            <span>2.</span>
            <h2>BETA VERSION FIRMWARE</h2>
          </SectionTitle>
          <SectionContent>
            <span></span>
            <div>
              AlphaTheta may terminate the beta version firmware (Beta Version
              Firmware) at any time, for any reason and without prior notice to
              You. You shall retain the Beta Version Firmware under your
              control. You shall be liable for any loss or damage in respect of
              the Beta Version Firmware or AlphaTheta's intellectual property
              rights in the Beta Version Firmware (including, but without
              limitation, any loss or damage arising from disclosure of the
              Firmware). You shall immediately inform AlphaTheta if You become
              aware that the Beta Version Firmware provided to You has been
              leaked or transferred to a third party and shall use Your best
              efforts to recover the Beta Version Firmware and prevent further
              leaks.
            </div>
          </SectionContent>

          <SectionTitle>
            <span>3.</span>
            <h2>PROGRAM LICENSE</h2>
          </SectionTitle>
          <SectionContent>
            <span>3.1</span>
            <div>
              <p>
                Limited License. Subject to these Terms of Use’s restrictions,
                AlphaTheta grants to You a limited, non-exclusive,
                non-transferable, license (without the right to sublicense):
              </p>
              <p>
                (a) To install a single copy of the Firmware in Your hardware,
                to use the Firmware only for testing and evaluation purpose and
                for Your analysis of music played at Your events subject to Your
                complying with these Terms of Use and the Documentation
                (“Authorized Use”); and
              </p>
              <p>
                (b) To use the Documentation in support of Your Authorized Use.
              </p>
            </div>
          </SectionContent>
          <SectionContent>
            <span>3.2</span>
            <div>
              Restrictions. You will not copy or use the Firmware or
              Documentation except as expressly permitted by these Terms of Use.
              You will not transfer, sublicense, rent, lease or lend the
              Firmware, or use it for third-party training, commercial
              time-sharing or service bureau use. AlphaTheta shall retain all
              rights in the Firmware (including all intellectual property rights
              in the Firmware) other than those expressly granted to you in
              these Terms of Use. The permissions in this Section 3 (Program
              License) DOES NOT include the right to (a) rent, lease, sublicense
              or make the Firmware available to third parties or on a network;
              (b) modify, alter, adapt, reverse engineer, decompile or
              disassemble the Firmware; (c) create derivative works from the
              Firmware; and (d) reproduce, perform or publicly transmit the
              Firmware in any unauthorized manner.
            </div>
          </SectionContent>
          <SectionContent>
            <span>3.3</span>
            <div>
              Ownership. AlphaTheta or its licensor retains all right, title and
              interest in and to all patent, copyright, trademark, trade secret
              and other intellectual property rights in the Firmware and
              Documentation, and any derivative works thereof. You do not
              acquire any other rights, express or implied, beyond the limited
              license set forth in these Terms of Use.
            </div>
          </SectionContent>
          <SectionContent>
            <span>3.4</span>
            <div>
              No Support. AlphaTheta has no obligation to provide support,
              maintenance, upgrades, modifications or new releases for the
              Firmware or Documentation under these Terms of Use.
            </div>
          </SectionContent>

          <SectionTitle>
            <span>4.</span>
            <h2>CONFIDENTIAL</h2>
          </SectionTitle>
          <SectionContent>
            You agree that
          </SectionContent>
          <SectionContent>
            <span>a)</span>
            <div>
              The Firmware, Documentation and any information relating to the
              use of the Firmware is confidential information of AlphaTheta. You
              may only use the Firmware and Documentation in Your venue for the
              purpose of Authorized Use and shall not transfer, distribute or
              disclose the Firmware, Documentation any other information
              relating to the Firmware to any third party except with
              AlphaTheta's prior written consent. You shall not share your
              experience of using the Firmware with any third party, nor shall
              you publish or disseminate such information.
            </div>
          </SectionContent>
          <SectionContent>
            <span>b)</span>
            <div>
              The Firmware has been tested to a reasonable extent. However, the
              Firmware contains unpublished software and may be incomplete or
              contain defects; Firmware may cause system errors, loss of
              functionality or performance, corruption or loss of data or
              content to hardware owned by You. Firmware contains development
              stage material that is not publicly available or viewable.
            </div>
          </SectionContent>
          <SectionContent>
            <span>c)</span>
            <div>
              Features provided in the Firmware may not be available at the time
              of public release and AlphaTheta makes no guarantee that the
              Firmware or any features contained therein will be provided or
              available in the future.
            </div>
          </SectionContent>
          <SectionContent>
            <span>d)</span>
            <div>
              Disclosure of the Firmware and Your experience in using the
              Firmware to third parties (including the media, news agencies and
              AlphaTheta's competitors) will cause AlphaTheta material and
              irreparable damage, the extent of which is difficult to determine.
              Accordingly, AlphaTheta shall be entitled to injunctive relief in
              addition to any other legal remedies in the event of a breach of
              these Terms of Use by You.
            </div>
          </SectionContent>

          <SectionTitle>
            <span>5.</span>
            <h2>UPDATES AND ONLINE SERVER SUPPORT</h2>
          </SectionTitle>
          <SectionContent>
            <span></span>
            <div>
              These Terms of Use also applies to updated versions of the
              Firmware (including any downloadable content for the Firmware).
              AlphaTheta may modify the Firmware at any time and for any reason,
              whether by automatic updates or otherwise, and You agree to
              AlphaTheta's distribution and delivery of such automatic updates.
              To the extent permitted by applicable law, AlphaTheta shall not be
              liable for any harm or damage caused to you in connection with
              such updates or the installation process. The provisions of these
              Terms of Use shall apply to all updates unless such update is
              accompanied by its own terms of use or license. If Firmware uses
              online servers, AlphaTheta cannot promise that such servers will
              be available at all times or at any particular time.
            </div>
          </SectionContent>

          <SectionTitle>
            <span>6.</span>
            <h2>INTERNET CONNECTION</h2>
          </SectionTitle>
          <SectionContent>
            <span></span>
            <div>
              Certain Firmware functions require an internet connection and any
              costs associated with the internet connection are the
              responsibility of You. You shall be responsible for all costs and
              charges levied by the Internet Service Provider in connection with
              the downloading and use of the Firmware.
            </div>
          </SectionContent>

          <SectionTitle>
            <span>7.</span>
            <h2>WARRANTY DISCLAIMER</h2>
          </SectionTitle>
          <SectionContent>
            <span></span>
            <div>
              TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE FIRMWARE
              AND ANY RELATED SERVICES ARE PROVIDED ON AN "AS IS" AND "AS
              AVAILABLE" BASIS AND WITHOUT WARRANTY OF ANY KIND AS TO ALL
              DEFECTS AND, TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW,
              ALPHATHETA AND ITS AFFILIATES AND LICENSORS (COLLECTIVELY,
              "ALPHATHETA" WITHIN THIS SECTION 7 “WARRANTY DISCLAIMER”)
              EXPRESSLY DISCLAIM ALL WARRANTIES, EXPRESS, IMPLIED OR STATUTORY,
              INCLUDING WITHOUT LIMITATION ANY WARRANTIES OF MERCHANTABILITY,
              COMPLETENESS, ACCURACY, FITNESS FOR A PARTICULAR PURPOSE OR
              NON-INFRINGEMENT OF THIRD PARTY RIGHTS. ALPHATHETA DOES NOT
              WARRANT THAT THE OPERATION OF THE FIRMWARE WILL BE UNINTERRUPTED
              OR ERROR-FREE, THAT THE FIRMWARE WILL BE COMPATIBLE WITH HARDWARE
              OTHER THAN THAT SPECIFIED, OR THAT THE FIRMWARE WILL OPERATE
              PROPERLY AND BE COMPATIBLE WITH THIRD PARTY SOFTWARE, CONTENT OR
              SERVICES.<br/>
              ALPHATHETA MAY TERMINATE SUPPORT FOR THE FIRMWARE AT ANY TIME AND
              IN ITS SOLE DISCRETION, AND ALPHATHETA WILL NOT BE LIABLE FOR ANY
              SUCH TERMINATION. TO THE EXTENT NOT PROHIBITED BY APPLICABLE LAW,
              ALPHATHETA SHALL NOT BE LIABLE TO YOU FOR ANY CLAIM ARISING OUT OF
              OR RELATING TO THE TERMS OF USE OR THE FIRMWARE, WHETHER IN TORT
              (INCLUDING NEGLIGENCE), CONTRACT LIABILITY, NO-FAULT LIABILITY OR
              OTHERWISE. TO THE EXTENT NOT PROHIBITED BY APPLICABLE LAW, IN NO
              EVENT SHALL ALPHATHETA BE LIABLE FOR PERSONAL INJURY, PROPERTY
              DAMAGE, LOST PROFITS, REPLACEMENT COSTS, LOSS OF DATA, OR ANY FORM
              OF DIRECT OR INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL OR
              PUNITIVE DAMAGES. IN NO EVENT SHALL ALPHATHETA'S TOTAL LIABILITY
              TO YOU EXCEED USD 10. SOME OR ALL OF THE ABOVE EXCLUSIONS AND
              LIMITATIONS MAY NOT APPLY IN JURISDICTIONS THAT DO NOT ALLOW
              CERTAIN LIMITATIONS OF LIABILITY OR DISCLAIMERS OR LIMITATIONS OF
              WARRANTIES, INCLUDING BODILY INJURY.
            </div>
          </SectionContent>

          <SectionTitle>
            <span>8.</span>
            <h2>EXPORT CONTROL AND COMPLIANCE WITH LAWS AND REGULATIONS</h2>
          </SectionTitle>
          <SectionContent>
            <span></span>
            <div>
              You may not use or otherwise export or re-export the Firmware
              except as authorized by United States law and the laws of the
              jurisdiction in which the Firmware was obtained. In particular,
              but without limitation, the Firmware may not be exported or
              re-exported (a) into any U.S.-embargoed countries or (b) to anyone
              on the U.S. Treasury Department's Specially Designated Nationals
              List or the U.S. Department of Commerce Denied Persons List or
              Entity List. By using the Firmware, You represent and warrant that
              You are not located in any such country or on any such list. You
              also agree that you will not use the Firmware for any purposes
              prohibited by United States law, including, without limitation,
              the development, design, manufacture, or production of nuclear,
              missile, or chemical or biological weapons.
            </div>
          </SectionContent>

          <SectionTitle>
            <span>9.</span>
            <h2>U.S. GOVERNMENT RESTRICTED RIGHTS</h2>
          </SectionTitle>
          <SectionContent>
            <span></span>
            <div>
              The Firmware and Documentations are “commercial computer software”
              and “commercial computer software documentation” as those terms
              are defined in 48 C.F.R. §252.227-7014 (a) (1) (2007) and
              252.227-7014 (a) (5) (2007). The U.S. Government’s rights with
              respect to the Firmware and Documentation are limited by this
              license pursuant to 48 C.F.R. § 12.212 (Computer software) (1995)
              and 48 C.F.R. §12.211 (Technical data) (1995) and/or 48 C.F.R.
              §227.7202-3, as applicable. As such, the Firmware and
              Documentations are being licensed to the U.S. Government end
              users: (a) only as “commercial items” as that terms is defined in
              48 C.F.R. §2.101 generally and as incorporated in DFAR 212.102;
              and (b) with only those limited rights as are granted to the
              public pursuant to this license. Under no circumstance will the
              U.S. Government or its end users be granted any greater rights
              than we grant to other users, as provided for in this license.
              Manufacturer is AlphaTheta Corporation, 6F, Yokohama i-Mark Place
              4-4-5 Minatomirai, Nishi-ku, Yokohama, Kanagawa 220-0012 Japan.
            </div>
          </SectionContent>

          <SectionTitle>
            <span>10.</span>
            <h2>DAMAGES AND REMEDIES FOR BREACH</h2>
          </SectionTitle>
          <SectionContent>
            <span></span>
            <div>
              You agree that any breach of these Terms of Use restrictions would
              cause AlphaTheta irreparable harm for which money damages alone
              would be inadequate. In addition to damages and any other remedies
              to which AlphaTheta may be entitled, You agree that AlphaTheta may
              seek injunctive relief to prevent the actual, threatened or
              continued breach of these Terms of Use.
            </div>
          </SectionContent>

          <SectionTitle>
            <span>11.</span>
            <h2>TERMINATION</h2>
          </SectionTitle>
          <SectionContent>
            <span></span>
            <div>
              AlphaTheta may terminate these Terms of Use at any time upon Your
              breach of any provision. If these Terms of Use are terminated, You
              will stop using the Firmware, permanently delete it from Your
              hardware where it resides, and destroy all copies of the Firmware
              and Documentation in Your possession, confirming to AlphaTheta in
              writing that You have done so. Sections 2 (BETA VERSION FIRMWARE),
              3 (PROGRAM LICENSE), 4 (CONFIDENTIAL), 7 (WARRANTY DISCLAIMER), 8
              (EXPORT CONTROL AND COMPLIANCE WITH LAWS AND REGULATIONS), 9 (U.S.
              GOVERNMENT RESTRICTED RIGHTS), 10 ( DAMAGES AND REMEDIES FOR
              BREACH), 11 (TERMINATION) and 12 (GENERAL TERMS) will continue in
              effect after these Terms of Use terminate.
            </div>
          </SectionContent>

          <SectionTitle>
            <span>12.</span>
            <h2>GENERAL TERMS</h2>
          </SectionTitle>
          <SectionContent>
            <span>12.1.</span>
            <div>
              Severability and Waiver. If any provision of these Terms of Use is
              held to be illegal, invalid or otherwise unenforceable, that
              provision will be enforced to the extent possible or, if incapable
              of enforcement, deemed to be severed and deleted from these Terms
              of Use, and the remainder will continue in full force and effect.
              The waiver by either party of any default or breach of these Terms
              of Use will not waive any other or subsequent default or breach.
            </div>
          </SectionContent>
          <SectionContent>
            <span>12.2.</span>
            <div>
              No Assignment. You may not assign, sell, transfer, delegate or
              otherwise dispose of these Terms of Use or any rights or
              obligations under them, whether voluntarily or involuntarily, by
              operation of law or otherwise, without AlphaTheta’s prior written
              consent. Any purported assignment, transfer or delegation by You
              will be null and void. Subject to the foregoing, these Terms of
              Use will be binding upon and will inure to the benefit of the
              parties and their respective successors and assigns.
            </div>
          </SectionContent>
          <SectionContent>
            <span>12.3.</span>
            <div>
              Entire Agreement. These Terms of Use and the terms of the Kuvo
              Venue Registration Consent Form constitute the entire agreement
              between the parties and supersedes all prior or contemporaneous
              agreements or representations, whether written or oral, concerning
              its subject matter. These Terms of Use may not be modified or
              amended without AlphaTheta’s prior and express written consent,
              and no other act, document, usage or custom will be deemed to
              amend or modify these Terms of Use.
            </div>
          </SectionContent>
          <SectionContent>
            <span>12.4.</span>
            <div>
              <p>
                Law and Arbitration. You agree that these Terms of Use and the
                terms of the Kuvo Venue Registration Consent Form shall be
                governed and construed by and under the laws of Japan. Any
                difference or dispute between the parties concerning the
                interpretation or validity of these Terms of Use or the rights
                and
                liability of the parties shall be settled by arbitration in
                Tokyo,
                Japan in accordance with the Commercial Arbitration Rules of The
                Japan Commercial Arbitration Association. The award thereof
                shall
                be final and binding upon the parties hereto. Judgement upon
                such
                award may be entered in any court having jurisdiction thereof.
              </p>
              <p>
                You agree to observe and comply at your sole cost and expense
                with all applicable laws (including but not limited to the
                governing law set out above in this clause 12.4, as well as all
                relevant data protection laws), ordinances, rules, regulations,
                and requirements of any governmental authority, as may be
                applicable to you in connection with your use of the Firmware
                and your obligations under these Terms of Use.
              </p>
            </div>
          </SectionContent>

        </DocumentContent>
      </Page>
  );
}
